export { registerController, scan } from "./registry";

import { scan } from "./registry";

// Import controllers
import "./controllers/sidebar";
import "./controllers/modal";
import "./controllers/calendar";
import "./controllers/mobile-nav";
import "./controllers/color-picker";
import "./controllers/event-form";
import "./controllers/composite-add";

// Boot
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => scan());
} else {
  scan();
}
